import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { FloatingAudioPlayerComponent } from './components/floating-audio-player/floating-audio-player.component';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, FloatingAudioPlayerComponent]
})
export class AppComponent implements OnInit {
  private meta = inject(Meta);

  ngOnInit(): void {
    const env = environment.environment;
    this.meta.updateTag({ name: 'environment', content: env });
    this.meta.updateTag({ name: 'enviroment', content: env });
  }
}
